var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.3a.8.8 0 01.8-.8h11.4a.8.8 0 01.8.8v9.4a.8.8 0 01-.8.8H2.3a.8.8 0 01-.8-.8V3.3z",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3l5.556 3.704a.8.8 0 00.888 0L14 3",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMS41IDMuM0MxLjUgMi44NTgxNyAxLjg1ODE3IDIuNSAyLjMgMi41SDEzLjdDMTQuMTQxOCAyLjUgMTQuNSAyLjg1ODE3IDE0LjUgMy4zVjEyLjdDMTQuNSAxMy4xNDE4IDE0LjE0MTggMTMuNSAxMy43IDEzLjVIMi4zQzEuODU4MTcgMTMuNSAxLjUgMTMuMTQxOCAxLjUgMTIuN1YzLjNaIiBzdHJva2U9IiM3RDgwODUiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KICA8cGF0aCBkPSJNMiAzTDcuNTU2MjQgNi43MDQxNkM3LjgyNDk2IDYuODgzMzEgOC4xNzUwNCA2Ljg4MzMxIDguNDQzNzYgNi43MDQxNkwxNCAzIiBzdHJva2U9IiM3RDgwODUiIHN0cm9rZS13aWR0aD0iMS4yIi8+Cjwvc3ZnPg==";
export { SvgInbox as ReactComponent };